import { TMarketItem } from '~types/Market.types'

export const getMarketItemMinPrice = (marketItem: TMarketItem) => {
	const { pricing } = marketItem

	if (pricing.unique) return pricing.basePrice

	return Math.min(...pricing.list.map(({ price }) => price))
}
